import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { credibilityBadges, images, testimonials } from '../data/content';
export function CredibilitySection() {
  return <section id="credibility" className="w-full border-y border-line bg-canvas" data-id="element-45" data-mp="28uroptva8n98">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-46" data-mp="2domdhbpqvsf6">
        <div className="grid gap-8 lg:grid-cols-[1fr_0.85fr] lg:items-center lg:gap-14" data-id="element-47" data-mp="2ilmcx3s39wxb">
          <div data-id="element-48" data-mp="1l08h10eb145q">
            <h2 className="font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-49" data-mp="1l0qc3tp8dcc2">
              Built by people who understand the business behind real estate.
            </h2>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-600 md:mt-6 md:text-[17px]" data-id="element-50" data-mp="1uzfvjqwrz4uf">
              HomeSmart NEXT brings together real estate, brokerage, MLS, title and escrow, technology, operations,
              marketing, and agent-growth experience. We understand that the best agents do not need more noise. They
              need better systems, better support, and more consistency behind the scenes.
            </p>
          </div>

          <div className="overflow-hidden rounded-2xl" data-id="element-51" data-mp="cza2ne8r68ro">
            <img src={images.team} alt="Real estate professionals meeting around a conference table with a desert mountain view" width={1680} height={945} loading="lazy" decoding="async" style={{
            objectPosition: 'center 40%'
          }} className="h-[220px] w-full object-cover md:h-[300px] lg:h-[340px]" data-id="element-52" data-mp="8wdhpgvqq0kk" />
          </div>
        </div>

        <ul className="mt-10 grid gap-4 md:mt-14 md:grid-cols-3" data-id="element-53" data-mp="3lebmsg1nxihe">
          {testimonials.map((item, i) => <li key={i} className="flex h-full flex-col rounded-2xl border border-line bg-white p-6" data-id="element-54" data-mp="3he1gt3dves2j" data-mpi={i}>
              <QuoteIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-55" data-mp="3ccc83ue4eqhm" />
              <blockquote className="mt-4 text-[15px] leading-relaxed text-ink" data-id="element-56" data-mp="37fbxd66bszk6">{item.quote}</blockquote>
              <div className="mt-auto pt-6" data-id="element-57" data-mp="2xotxyghsh3nt">
                <p className="font-display text-[15px] font-semibold text-ink" data-id="element-58" data-mp="32p86s0r7shmw">{item.name}</p>
                <p className="mt-0.5 text-[13px] text-ink-400" data-id="element-59" data-mp="2ns8sxv5rrsjz">{item.detail}</p>
              </div>
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap gap-2.5" data-id="element-60" data-mp="2ssd8niyusj95">
          {credibilityBadges.map(badge => <li key={badge} className="rounded-full border border-line bg-white px-3.5 py-2 text-[12px] font-semibold uppercase tracking-[0.08em] text-ink-600" data-id="element-61" data-mp="3ghxx2hds08pt">
              {badge}
            </li>)}
        </ul>
      </div>
    </section>;
}